import { useParams, Link } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { posts } from './posts';
import './Blog.css';
import logo from '../assets/reel-easy-logo.png';

export default function BlogPost() {
  const { slug } = useParams<{ slug: string }>();
  const post = posts.find(p => p.slug === slug);

  if (!post) {
    return (
      <div className="blog-page">
        <div className="container" style={{ padding: '4rem 2rem', textAlign: 'center' }}>
          <p style={{ color: '#94a3b8' }}>Post not found.</p>
          <Link to="/blog" className="back-home">← Back to blog</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="blog-page">
      <header className="blog-header">
        <div className="container">
          <Link to="/">
            <img src={logo} alt="Reel Easy Retreat" className="blog-logo" />
          </Link>
        </div>
      </header>

      <main className="blog-main">
        <div className="container">
          <Link to="/blog" className="back-home" style={{ display: 'inline-block', marginBottom: '2rem' }}>← All posts</Link>
          <article className="post-full">
            <time className="post-date">{new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</time>
            <h1 className="post-full-title">{post.title}</h1>
            <div className="post-body">
              <ReactMarkdown>{post.content}</ReactMarkdown>
            </div>
          </article>
        </div>
      </main>

      <footer className="blog-footer">
        <div className="container">
          <Link to="/" className="back-home">← Back to Reel Easy Retreat</Link>
        </div>
      </footer>
    </div>
  );
}
